import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {routes} from "../Routes";
import SingleStatement from "../../views/statements/single/SingleStatement";
import CompanySettings from "../../views/companies/CompanySettings";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {useRouteWithParam} from "../../components/RouteWithParam";
import TransactionsPreviewForPrinting from "../../views/statements/single/TransactionsPreviewForPrinting";
import {ReviewPurchaseInvoices} from "../../views/invoice/review/ReviewPurchaseInvoices";
import {useSalesInvoiceRoutes} from "../SalesInvoiceRoutes";
import CustomersList from "../../views/customer/CustomersList";
import {CustomerBillingPlan} from "../../views/billing/CustomerBillingPlan";
import {ReviewSalesInvoices} from "../../views/invoice/review/ReviewSalesInvoices";
import AccountList from "../../views/account/AccountList";
import StatementDownloadLog from "../../views/statements/StatementDownloadLog";
import PartyList from "../../views/parties/PartyList";
import RulesList from "../../views/rules/RulesList";
import CompaniesTable from "../../views/companies/CompaniesTable";
import StatementsTableTab from "../../views/statements/list/StatementsTableTab";
import Loader from "../../components/Loader";
import {lhvConnectApi} from "../../backend/LhvConnectApi";
import {wiseConnectionApi} from "../../backend/WiseConnectionApi";
import AddEmployee from "../../views/employee/new/NewEmployeeWizard";
import DriveRedirect from "../../views/redirect/GoogleDriveRedirect";
import {EmailCommunicationView} from "../../views/communication/EmailCommunicationView";
import {RecognisePurchaseInvoices} from "../../views/invoice/recognise/RecognisePurchaseInvoices";

export default function AccountantRoutes() {
    return <>
        <Routes>
            {useRouteWithParam({path: routes.singleStatement, render: params => <SingleStatement id={params.id!!}/>})}
            <Route path={routes.companySettings}
                   element={<CompanySettings companyId={selectedCompanyStore.companyId}/>}/>

            {useRouteWithParam({
                path: routes.previewForPrinting,
                render: params => <TransactionsPreviewForPrinting id={params.id!!}/>
            })}

            {useSalesInvoiceRoutes()}

            <Route path={routes.myClients} element={<CustomersList/>}/>

            <Route path={routes.addEmployee} element={<AddEmployee/>}/>
            <Route path={routes.billing} element={<CustomerBillingPlan/>}/>


            {useRouteWithParam({
                path: routes.reviewPurchaseInvoicesTaskId,
                render: params => <ReviewPurchaseInvoices taskId={params.id}/>
            })}
            <Route path={routes.reviewPurchaseInvoices} element={<ReviewPurchaseInvoices/>}/>

            {useRouteWithParam({
                path: routes.reviewSalesInvoicesTaskId,
                render: params => <ReviewSalesInvoices taskId={params.id}/>
            })}
            <Route path={routes.reviewSalesInvoices} element={<ReviewSalesInvoices/>}/>

            <Route path={routes.recognisePurchaseInvoices} element={<RecognisePurchaseInvoices/>}/>

            <Route path={routes.accounts} element={<AccountList/>}/>
            <Route path={routes.lhvConnect} element={<StatementDownloadLog api={lhvConnectApi}/>}/>
            <Route path={routes.wiseConnection} element={<StatementDownloadLog api={wiseConnectionApi}/>}/>
            <Route path={routes.parties} element={<PartyList/>}/>
            <Route path={routes.rules} element={<RulesList/>}/>
            <Route path={routes.myCompanies} element={<CompaniesTable/>}/>
            <Route path={routes.statements} element={<StatementsTableTab/>}/>

            <Route path={routes.communicateViaEmail} element={<EmailCommunicationView/>}/>

            <Route path={routes.driveRedirect} element={<DriveRedirect/>}/>

            <Route path="/temp" element={<Loader loading={true}/>}/>
            <Route path="/" element={<Navigate to={routes.statements} replace/>}/>
        </Routes>
    </>;
}
